import request from '@host-panel/request';
import { Request, Response } from './index';

export function removeFromAllowlist({
  userId,
  ip,
  applyOnHistory = false
}: Request): Promise<Response> {
  return request(`/host-panel/allowlist`, {
    method: 'DELETE',
    data: {
      ip,
      user: userId,
      apply_to_history: applyOnHistory
    }
  });
}
